<div class="page">
  <span class="eyebrow">Besök oss</span>
  <h1>Öppettider</h1>

  <div class="panel">
    <dl class="hours-list">
      <div class="hours-row">
        <dt>Måndag &ndash; Torsdag</dt>
        <dd>07:00 &ndash; 17:00</dd>
      </div>
      <div class="hours-row">
        <dt>Fredag</dt>
        <dd>07:00 &ndash; 16:00</dd>
      </div>
      <div class="hours-row hours-row--muted">
        <dt>Lunchstängt</dt>
        <dd>12:00 &ndash; 12:30</dd>
      </div>
      <div class="hours-row">
        <dt>Lördag <span class="hours-note">(däckskifte, säsong)</span></dt>
        <dd>08:00 &ndash; 13:00</dd>
      </div>
    </dl>
    <p class="hours-footnote">Lördagsöppet gäller inför vinter- och sommarsäsong för däckskifte.</p>
  </div>
</div>
